import { inject, Injectable } from '@angular/core';
import {
  IndexedDBService,
  StoredCategoryGate,
  StoredSeatCategory,
} from '../indexeddb/indexeddb.service';

interface SeatCategoryWithGates {
  id: number;
  name: string;
  color?: string;
  gates?: StoredCategoryGate[];
}

@Injectable({
  providedIn: 'root',
})
export class SeatCategoryCacheService {
  readonly #db = inject(IndexedDBService);

  async cacheSeatCategories(
    eventId: number,
    categories: SeatCategoryWithGates[],
  ): Promise<void> {
    const storedCategories: StoredSeatCategory[] = categories.map((cat) => ({
      event_id: eventId,
      id: cat.id,
      name: cat.name,
      color: cat.color ?? '',
      gates: cat.gates ?? [],
    }));

    await this.#db.seatCategories.bulkPut(storedCategories);
  }

  async getSeatCategory(
    eventId: number,
    categoryId: number,
  ): Promise<StoredSeatCategory | undefined> {
    return this.#db.seatCategories
      .where('[event_id+id]')
      .equals([eventId, categoryId])
      .first();
  }

  async getSeatCategoriesForEvent(
    eventId: number,
  ): Promise<StoredSeatCategory[]> {
    return this.#db.seatCategories.where('event_id').equals(eventId).toArray();
  }

  async clearEventCategories(eventId: number): Promise<void> {
    await this.#db.seatCategories.where('event_id').equals(eventId).delete();
  }
}
